var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder,"readonly":_vm.readonly,"maxlength":_vm.maxLength},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361737d0","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/components/InputPhone.vue
// module id = 868
// module chunks = 1